import { PAGES } from 'consts/pages';
import { PRESET_OPTIONS } from 'consts/dashboard';
import type { PresetOption } from 'consts/dashboard';
import type { Bookmark } from 'services/bookmark';

/** Saved views exist only for log searches, whatever page the bookmark is viewed from. */
export const supportsSavedView = (searchType: Bookmark['searchType'] | undefined): boolean => searchType === 'O_SENSOR';

/** Views are investigator-only, so a bookmark's view presets always come from that page. */
export const getViewPresetOptions = (profilesList: (string | null | undefined)[] | undefined): PresetOption[] =>
  (PRESET_OPTIONS[PAGES.investigator] ?? []).filter((preset) =>
    preset.profileTypes ? preset.profileTypes.some((profileType) => profilesList?.includes(profileType)) : true,
  );

export const filterBookmarks = <T extends Bookmark>(bookmarks: T[] = [], filter: string | undefined): T[] => {
  if (!filter) {
    return bookmarks;
  }
  const lowercasedFilter = filter.toLowerCase();

  return bookmarks.filter(
    (b) =>
      b.name?.toLowerCase().includes(lowercasedFilter) ||
      b.description?.toLowerCase().includes(lowercasedFilter) ||
      b.labels?.join(',').toLowerCase().includes(lowercasedFilter),
  );
};
